
import { Component, MixedVue } from "@/vue";
import { Prop, Ref } from "vue-property-decorator";
import { formatDate, getFeatureData, parseDate, setFeatureDataItem } from "../../lib/util";
import Modal from "../Modal.vue";

@Component({
  name: "PwaInstallPrompt",
  components: { Modal },
})
export default class PwaInstallPrompt extends MixedVue {
  static components: {
    Modal: typeof Modal;
  };

  @Prop({ type: Event, default: null })
  defferedInstallPrompt!: BeforeInstallPromptEvent;

  @Ref()
  modal: Modal;

  dismissedOnce = true;

  mounted() {
    const lastShownDate = parseDate(getFeatureData("pwaInstall").lastShownDate);
    const TWO_WEEKS = 14 * 24 * 60 * 60 * 1000;
    if (!lastShownDate || Date.now() >= lastShownDate.getTime() + TWO_WEEKS) {
      this.dismissedOnce = false;
    } else {
      this.dismissedOnce = true;
    }
  }

  get showInstallPrompt() {
    return this.defferedInstallPrompt && this.$store.getters.userEmail && !this.dismissedOnce;
  }

  async dismiss() {
    this.dismissedOnce = true;
    setFeatureDataItem("pwaInstall", "lastShownDate", formatDate(new Date()));
    this.$emit("dismiss");
  }

  async handleInstallPrompt() {
    this.defferedInstallPrompt.prompt();
    const { outcome } = await this.defferedInstallPrompt.userChoice;
    if (outcome == "accepted") {
      this.dismissedOnce = true;
      this.$emit("dismiss");
    } else if (outcome == "dismissed") {
      this.$emit("dismiss");
    }
  }
}
